import { Button } from '@/components/Button'
import { CodeInput } from '@/shared/Auth/components/CodeInput'
import { CommonError } from '@/shared/Auth/components/CommonError'
import { Row } from '@/shared/Auth/components/Row'
import { Title } from '@/shared/Auth/components/Title'
import { FC, useCallback, useEffect, useState } from 'react'
import styles from './ConfirmResetPassword.module.scss'

interface ConfirmResetPasswordProps {
  className?: string
  email: string
  code: string
  setCode: (value: string) => void
  error: boolean
  onRequestRetry: () => void
}

export const ConfirmResetPassword: FC<ConfirmResetPasswordProps> = ({
  className,
  code,
  setCode,
  email,
  error,
  onRequestRetry,
}) => {
  const [timer, setTimer] = useState<number>(20)

  useEffect(() => {
    const interval = setInterval(
      () => setTimer((t) => (t > 0 ? t - 1 : 0)),
      1000
    )
    return () => clearInterval(interval)
  }, [])

  const requestRetry = useCallback(() => {
    setTimer(60)
    onRequestRetry()
  }, [onRequestRetry])

  return (
    <div className={className}>
      <Title title="Подтверждение сброса пароля" />

      <div className={styles.description}>
        Мы отправили письмо с кодом на e-mail:{' '}
        <span className={styles.descriptionAccent}>{email}</span>
      </div>

      <Row>
        <CodeInput onChange={setCode} name="code" value={code} />
      </Row>

      {error ? (
        <CommonError errors={{ _common: 'Введенный код не верен' }} />
      ) : null}

      <Row>
        <Button
          className={styles.button}
          onClick={requestRetry}
          disabled={timer > 0}
        >
          {timer > 0
            ? `Отправить код повторно, через ${timer} сек.`
            : 'Отправить код повторно'}
        </Button>
      </Row>
    </div>
  )
}
